/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData model module.
 * @module model/LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData
 * @version 1.0
 */
class LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData {
    /**
     * Constructs a new <code>LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData</code>.
     * @alias module:model/LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData
     */
    constructor() { 
        
        LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData} The populated <code>LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData();

            if (data.hasOwnProperty('logNo')) {
                obj['logNo'] = ApiClient.convertToType(data['logNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('gemId')) {
                obj['gemId'] = ApiClient.convertToType(data['gemId'], 'Number');
            }
            if (data.hasOwnProperty('gemName')) {
                obj['gemName'] = ApiClient.convertToType(data['gemName'], 'String');
            }
            if (data.hasOwnProperty('socketIndex')) {
                obj['socketIndex'] = ApiClient.convertToType(data['socketIndex'], 'Number');
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['gemName'] && !(typeof data['gemName'] === 'string' || data['gemName'] instanceof String)) {
            throw new Error("Expected the field `gemName` to be a primitive type in the JSON string but got " + data['gemName']);
        }
        // ensure the json data is a string
        if (data['type'] && !(typeof data['type'] === 'string' || data['type'] instanceof String)) {
            throw new Error("Expected the field `type` to be a primitive type in the JSON string but got " + data['type']);
        }

        return true;
    }


}



/**
 * @member {Number} logNo
 */
LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData.prototype['logNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData.prototype['email'] = undefined;

/**
 * @member {Number} nftUid
 */
LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData.prototype['nftUid'] = undefined;

/**
 * @member {Number} gemId
 */
LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData.prototype['gemId'] = undefined;

/**
 * @member {String} gemName
 */
LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData.prototype['gemName'] = undefined;

/**
 * @member {Number} socketIndex
 */
LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData.prototype['socketIndex'] = undefined;

/**
 * @member {String} type
 */
LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData.prototype['type'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData.prototype['createdAt'] = undefined;






export default LogControllerDtoGemSocketUpdateLogListGemSocketUpdateLogData;

